<template>
  <div
    ref="lookbookImagesContainer"
    class="lookbook-images__container grid"
  >
    <slot />
  </div>
</template>

<script>

export default {
  name: 'HorizontalScrollManager',

  data() {
    return {
      scrollElementActive: false,
    }
  },

  mounted() {
    const mediaQuery = window.matchMedia('(min-width: 1024px)')
    mediaQuery.addEventListener('change', (event) => {
      this.handleMediaQuery(event)
    })

    if (mediaQuery.matches) {
      this.scrollAnimation()
    }
  },

  methods: {
    handleMediaQuery(event) {
      if (event.matches) {
        this.scrollAnimation()
      } else {
        this.resetScrollAnimation()
      }
    },

    resetScrollAnimation() {
      this.scrollElementActive = false
      const horizontalSection = this.$refs.lookbookImagesContainer
      const scrollElement = this.$refs.lookbookImagesContainer.parentElement
      horizontalSection.style.transform = 'translateX(0)'
      scrollElement.style.removeProperty('height')
    },

    handleScroll(horizontalSection, scrollElement) {
      if (scrollElement.getBoundingClientRect().top < -100) {
        if (scrollElement.getBoundingClientRect().top * -1 <=
          (horizontalSection.scrollWidth - window.innerWidth + 110)) {
          horizontalSection.style.transform = `translateX(${scrollElement.getBoundingClientRect().top + 100}px)`
        }
      } else {
        horizontalSection.style.transform = `translateX(0)`
      }
    },

    scrollAnimation() {
      if (!this.scrollAnimationActive) {
        const horizontalSection = this.$refs.lookbookImagesContainer
        const scrollElement = this.$refs.lookbookImagesContainer.parentElement

        scrollElement.style.height = `${50 + horizontalSection.scrollWidth - (horizontalSection.getBoundingClientRect().height / 2)}px`

        window.addEventListener('resize', () => {
          if (this.scrollElementActive) {
            scrollElement.style.height = `${50 + horizontalSection.scrollWidth - (horizontalSection.getBoundingClientRect().height / 2)}px`
          }
        })

        window.addEventListener(
          'scroll',
          () => {
            if (this.scrollElementActive) {
              this.handleScroll(horizontalSection, scrollElement)
            }
          },
          { passive: true },
        )

        this.scrollElementActive = true
      }
    },
  },
}
</script>
